/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../../components/table/CustomTable";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import {VehicleMovementsTableApp} from "../../Functionality/VehicleMovements/VehicleMovementsTableApp";

const VehicleMovementsTable = ({
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSearch,
    setSimpleSearch,
    finalArray,
    modified,
    setModified,
    setCriteria
}) => {
    const {
        t,
        navigate,
        permission,
        DEV,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        deletePermission,
        getData
    } = VehicleMovementsTableApp({
        selectedList,
        setSelectedList,
        setIsAllChecked,
        option,
        setBodyForExport,
        searchElement,
        finalArray,
        modified,
        setModified,
        setCriteria,
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
                // The simple search drops the filters of the advanced search, so the
                // export goes back to the simple endpoint along with the table
                callApi={() => {
                    setSearch(false);
                    getData(0, {searchElement});
                }}
                resetApi={() => {
                    setSearch(false);
                    getData(0, {searchElement: ''});
                }}
            />
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_dont_have_any_vehicle_movements_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_VEHICLE_MOVEMENTS_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_vmt_create'} card={true}
                                                   onClick={() => navigate(routes.vehicleMovements.create)}
                                                   name={'create_new_vehicle_movement'}/>
                                 } </>
                             : undefined
                         }
            />
            {pagination()}
        </>
    );
};

export default VehicleMovementsTable;
